import classNames from "classnames";
import { FC } from "react";

import ShabuDaysLogo from "../../assets/images/ShabuDaysHeaderLogo.png";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { Image } from "../elements";
import "./Logo_kokoro.scss";
import "./Logo_shabuDays.scss";

interface ILogoProps {
	"data-testid"?: string;
	className?: string;
}

const Logo: FC<ILogoProps> = (props) => {
	const { state: location } = useConfigContext((state) => state.location);

	return (
		<div
			data-testid={props["data-testid"] ?? "LogoCntr"}
			className={classNames("LogoCntr", props.className)}
		>
			<Image src={ShabuDaysLogo} alt="Shabu Days" className="Logo" />
			{location?.name && <span className="LogoText">{location.name}</span>}
		</div>
	);
};

export default Logo;
